import React from 'react';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';

import assets from 'marketing-website/configs/pages/resources/assets.js';
import ResourcesCard from 'marketing-website/pages/resources/_ResourcesCard';

import styles from './styles/general.module.css';

export default function HeadingCards() {
  return (
    <div>
      <h1 className={styles.heading}>Resources Hub</h1>
      <Spacing size="l" type="margin" position="bottom">
        <MaxWidth value={500}>
          <h2 className={styles.subheading}>
            A library of educational gems that’ll get you up to speed with all
            things Marvel
          </h2>
        </MaxWidth>
      </Spacing>
      <Grid columns={12} size="m">
        <GridItem columnSpan={12} columnSpanM={4}>
          <ResourcesCard
            artwork={assets.events}
            title={"What's on"}
            excerpt={
              'Catch up on the latest from the team, from webinars to events'
            }
            url="#webinars"
          />
        </GridItem>
        <GridItem columnSpan={12} columnSpanM={4}>
          <ResourcesCard
            artwork={assets.product}
            title={'Product updates'}
            excerpt={'All our launches, news and ships in one place'}
            url="#productupdates"
          />
        </GridItem>
        <GridItem columnSpan={12} columnSpanM={4}>
          <ResourcesCard
            artwork={assets.guides}
            title={'Bits & Bobs'}
            excerpt={'Our collection of online guides and downloadable assets'}
            url="#bits+bobs"
          />
        </GridItem>
      </Grid>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/resources/_HeadingCards.js